import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import BahanBaku from "./pages/BahanBaku";
import Produk from "./pages/Produk";
import Produksi from "./pages/Produksi";
import Penjualan from "./pages/Penjualan";
import Riwayat from "./pages/Riwayat";
import Laporan from "./pages/Laporan";
import Asisten from "./pages/Asisten";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/bahan" element={<BahanBaku />} />
              <Route path="/produk" element={<Produk />} />
              <Route path="/produksi" element={<Produksi />} />
              <Route path="/penjualan" element={<Penjualan />} />
              <Route path="/riwayat" element={<Riwayat />} />
              <Route path="/laporan" element={<Laporan />} />
              <Route path="/asisten" element={<Asisten />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
